import { Spreadsheet } from "@syncfusion/ej2/spreadsheet";
import { Select2Helper } from "../../Helpers/Select2Helper";
import { StringHelper } from "../../Helpers/StringHelper";
import { Toastr } from "../../Helpers/Toastr";
import { SelectedExcelCellModel } from "../../Models/Excel/SelectedExcelCellModel";
import { CellOriginalBackgroundColor } from "../../Models/Excel/CellOriginalBackgroundColor";
import { ExcelFormatDataService } from "../../DataService/ExcelFormatDataService";

export class WritePricesToSheetManager {

    constructor(private containerElement: JQuery) { }

    private form : JQuery<HTMLElement>;
    private submitButton : JQuery<HTMLElement>;
    private docHeaderId : string;
    private excelFormatId : string | undefined;

    private spreadsheet : Spreadsheet
    private currentSelectedCellRange : string;

    private currentSelectedCells : SelectedExcelCellModel[] = [];
    private cellOriginalBackgroundColors : CellOriginalBackgroundColor[] = [];

    public initialize() {
        var self = this;

        this.bindElements();
        this.bindEvents();
    }

    private bindElements() {
        var self = this;

        self.docHeaderId = self.containerElement.children().first().data('doc-header-id');
        self.excelFormatId = self.containerElement.children().first().data('format-id');

        self.form = this.containerElement.find('form');
        self.submitButton = self.form.find('button:submit');
        self.submitButton.prop('disabled', true);
    }

    private bindEvents() {
        var self = this;

        self.spreadsheet = new Spreadsheet( {
            showRibbon: false,
            showAggregate: false,
            showFormulaBar: false,
            locale: 'en',
            listSeparator: ';',
            selectionSettings: {
                mode: "Single"
            },
            allowEditing: false,
            height: '80vh',
            openUrl: '/api/company/excel/open',
            created: (): void => {
                fetch(`/api/company/datawarehouse/${self.docHeaderId}/workbook`) // fetch the remote url
                    .then((response) => {
                        response.blob().then((fileBlob) => { // convert the excel file to blob
                            let file = new File([fileBlob], "Sample.xlsx");
                            self.spreadsheet.open({ file: file }); // open the file into Spreadsheet
                        })
                    })
            },
            openComplete: (args: any) => {
                if(args.response.data == 'NeedPassword' || args.response.data == 'InCorrectPassword') {
                    //spreadsheetElement.removeClass('d-none');
                }
                else if(args.response.data == 'UnsupportedFile') {
                    //spreadsheetElement.removeClass('d-none');
                }
                else {
                    self.spreadsheet.selectRange('A1:A1');
                    self.currentSelectedCellRange = "A1:A1";

                    setTimeout(() => {
                        self.spreadsheet.freezePanes(0, 0);  
                    }, 250)
                }

                if(self.excelFormatId != '' && self.excelFormatId != undefined) {
                    ExcelFormatDataService.getExcelFormatInfo(self.excelFormatId, (formatResult) => {
                        var mergedHeadersAndDetails = formatResult.headers.concat(formatResult.details);
                        mergedHeadersAndDetails.forEach(receivedFormatItem => {
                            var inputGroupForKey = self.containerElement.find(`.input-group[data-excel-format-item="${receivedFormatItem.key}"]`);
                            var selectCellButton = inputGroupForKey.find('button[data-action="select-cell"]');
                            
                            if(receivedFormatItem.addressRange != null && receivedFormatItem.addressRange != '') {
                                self.currentSelectedCellRange = receivedFormatItem.addressRange;
                                selectCellButton.trigger('click');
                            }
                        });
                    })
                }

                self.submitButton.prop('disabled', false);
            },
            select: (args: any) => {
                self.currentSelectedCellRange = args.range;
            }
        });
        self.spreadsheet.appendTo('#workbook-spreadsheet-container');

        self.containerElement.find('.input-group[data-excel-format-item]').each((index, element) => {
            var formatItem = $(element);
            var excelFormatItemKey = formatItem.data('excel-format-item');
            var formatItemType = formatItem.data('format-item-type');
            var descriptionBackgroundColor = formatItem.find('span').css('background-color');
            var columnAndRowInput = formatItem.find('input[data-column-and-row-input]');
            var columnAndRowValueInput = formatItem.find('input[data-column-and-row-value-input]');
            var selectCellButton = formatItem.find('button[data-action="select-cell"]');
            var deselectCellButton = formatItem.find('button[data-action="deselect-cell"]');

            if(columnAndRowInput.val() != '') {
                deselectCellButton.prop('disabled', false);
            }

            selectCellButton.off('click').on('click', () => {
                var cellRange = self.currentSelectedCellRange;
                self.spreadsheet.getData(cellRange).then((cells)=> {
                    var index = 0;
                    cells.forEach((cell, key)=>{
                        if(index == 0) {
                            if(self.selectCell(cellRange, excelFormatItemKey, formatItemType, descriptionBackgroundColor)) {
                                columnAndRowInput.val(cellRange);

                                var cellValue = cell.value;

                                cellValue = cellValue?.replace(/[\r\n]|[^\uD83C-\uDFFFa-zA-Z0-9\!\?\;\:\$\#\@\*\%\,\'\"\<\>\+\(\)\.\-\_]/g, ' ');

                                if(cellValue != undefined) {
                                    columnAndRowValueInput.val(cellValue);
                                    columnAndRowValueInput.attr('title', cellValue);
                                }
                                else {
                                    columnAndRowValueInput.val('');
                                    columnAndRowValueInput.attr('title', '');
                                }
                            }
                        }

                        index++;
                    })
                });
            })

            deselectCellButton.off('click').on('click', () => {
                var existingSelectedCellIndex = self.currentSelectedCells.findIndex(x => x.key == excelFormatItemKey );
                if(existingSelectedCellIndex != -1) {
                    self.deselectCell(existingSelectedCellIndex, true)
                }
            })
        })

        self.form.submit(function(e) {

            /* stop form from submitting normally */
            e.preventDefault();

            /* get some values from elements on the page: */
            var $form = $(this);
            var url = $form.attr('action');

            var data = $form.serialize();
            /* Send the data using post */
            //var posting = $.post(url, data, function(response) { console.log("1"); });

            $.ajax({
                type: "post",
                url: url,
                data: data,
                contentType: "application/x-www-form-urlencoded",
                success: function(responseData, textStatus, jqXHR) {
                    var fileMimeType = jqXHR.getResponseHeader('file_mime_type');
                    var fileName = jqXHR.getResponseHeader('file_name');


                    var bytes = Uint8Array.from(atob(responseData), c => c.charCodeAt(0))
                    var blob = new Blob([bytes],{type:`${fileMimeType}`})
                    var link= document.createElement('a')
                    link.href= window.URL.createObjectURL(blob)
                    link.download = `${fileName}`;
                    link.click()

                    self.containerElement.modal('hide');
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    Toastr.Error("Error occurred while creating file", jqXHR.responseText);
                    self.submitButton.prop('disabled', false);
                }
            })
        });
    }





    private selectCell(cellRange:string, formatItemKey:string, formatItemType: string, cellBackgroundColor: string) : boolean {
        var self = this;

        self.spreadsheet.unprotectSheet(self.spreadsheet.getActiveSheet().name);

        if(formatItemType != 'DetailOutbound') {
        
            var existingSelectedCellForDifferentKeyIndex = self.currentSelectedCells.findIndex(x => x.key != formatItemKey && x.cellRange == cellRange);
            if(existingSelectedCellForDifferentKeyIndex != -1) {
                self.deselectCell(existingSelectedCellForDifferentKeyIndex, true)
            }

            var existingSelectedCellForKeyIndex = self.currentSelectedCells.map(e => e.key).indexOf(formatItemKey);
            if(existingSelectedCellForKeyIndex != -1) {
                self.deselectCell(existingSelectedCellForKeyIndex, false)
            }
        }


        self.spreadsheet.getData(cellRange).then((cells) => {
            var index = 0;
            cells.forEach((cell, key)=>{
                if(index == 0) {
                    var inputGroupForKey = self.containerElement.find(`.input-group[data-excel-format-item="${formatItemKey}"]`);
                    inputGroupForKey.find('button[data-action="deselect-cell"]').prop('disabled', false);

                    var bgColor = cell.style?.backgroundColor;
                    self.cellOriginalBackgroundColors.push( {backgroundColor: bgColor ?? '', cellRange: cellRange});

                    self.currentSelectedCells.push( {key: formatItemKey, cellRange: cellRange});
                    self.spreadsheet.cellFormat({ backgroundColor: cellBackgroundColor }, cellRange);
                }

                index++;
            })
        })



        return true;
    }

    private deselectCell(selectedCellIndex : number, clearFormInputs : boolean) : boolean {
        var self = this;

        self.spreadsheet.unprotectSheet(self.spreadsheet.getActiveSheet().name);

        var cellToDeselect = self.currentSelectedCells[selectedCellIndex];

        var inputGroupForKey = self.containerElement.find(`.input-group[data-excel-format-item="${cellToDeselect.key}"]`);
        var formatItemType = inputGroupForKey.data('format-item-type');

        var originalBackgroundColor = this.cellOriginalBackgroundColors.find(x => x.cellRange == cellToDeselect.cellRange);

        self.spreadsheet.cellFormat({ backgroundColor: originalBackgroundColor != undefined ? originalBackgroundColor.backgroundColor : '' }, cellToDeselect.cellRange);
        self.currentSelectedCells.splice(selectedCellIndex, 1);

        if(clearFormInputs) {

            inputGroupForKey.find('input[data-column-and-row-input]').val('');
            inputGroupForKey.find('input[data-column-and-row-value-input]').val('');
            inputGroupForKey.find('button[data-action="deselect-cell"]').prop('disabled', true);
        }

        return true;
    }
}